import Styled from 'styled-components';

export default Styled.div`
    .labReportCardWrapper {
        border: 1px solid ${(props) => props?.theme?.color?.borderLight};
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        margin: 20px;

        .reportHeader {
            background: ${(props) => props?.theme?.blue?.iconBg};
            display: flex;
            flex-direction: row;
            width: 100%;
            align-items: center;
            padding: 10px 35px 10px 40px;
            border-radius: 8px 8px 0px 0px;

            .appointmentDetail{
                flex: 1;
                display: flex;
                flex-direction: row;
                .patient {
                    flex: 0.7;
                    .patientName{
                        color: ${(props) => props?.theme?.text?.medium};
                        font-size: 13px;
                        font-weight: 600;
                        line-height: 16px;
                    }
                    .docName{
                        color: ${(props) => props?.theme?.text?.dark};
                        font-size: 15px;
                        font-weight: 600;
                        line-height: 19px;
                        margin-top: 5px;
                    }
                }
                .appointmentDate{
                    flex: 1;
                    color: ${(props) => props?.theme?.text?.darkest};
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 16px;
                    margin-top: 2px;
                }
            }
            .buttonCTA {
                flex: 1;
                display: flex;
                justify-content: end;
            }
            .viewDetailsCTA{
                flex: 1;
                width:316px;
            }
        }
        .reportWrapper {
            display: flex;
            flex-wrap: wrap;
            padding: 19px 24px 4px 40px;
            .singleReport {
                width: 250px;
                height: 28px;
                margin-bottom: 16px;
                overflow: hidden;
                display: flex;
                align-items: center;
                div {
                    min-width: 28px;
                    min-height: 29px;
                }
            
                span {
                    max-width: 100%;
                    max-height: 28px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-family: 'Mulish';
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 22px;
                    color: ${(props) => props?.theme?.royalBlue?.DarkBlueGray};
                    margin-left: 8px;
                }
            }
        }
        .report_footer {
            .message_wrapper {
                height: 43px;
                min-height: 28px;
                background-color: ${(props) => props?.theme?.yellow?.off};
                display: flex;
                align-items: center;
                border-bottom-left-radius: 0.375rem;
                border-bottom-right-radius: 0.375rem;
                span {
                    font-family: 'Mulish';
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 20px;
                    color: ${(props) => props?.theme?.text?.darkest};
                    margin-left: 16px;
                }
            }
        }
    }

@media (max-width: 768px){
    .labReportCardWrapper{
        .viewDetailsCTA{
            width:260px !important;
        }
        .reportWrapper {
            .singleReport{
                width: 200px;
                margin-left: 5px;            
            }
        }
    }
}

@media (max-width: 425px){
    .labReportCardWrapper{
        .reportWrapper{
            padding-left: 10px;
            padding-top: 10px;
        }
        .reportHeader{
            padding: 15px;
            flex-direction: column;
            align-items: flex-start;
            .appointmentDetail{
                justify-content: space-between;
                display: flex;
                width: 100%;
                .appointmentDate{
                    left: 290px;
                    position: absolute;
                }
                .patient{
                    .docName{
                        margin-top: 6px;
                    }
                }
            }
        } 
        .viewDetailsCTA{
            width:90%!important;
            margin: 0px 15px 15px 15px ;
        }
        .reportWrapper {
            .singleReport{
                width:100%;
            }
        }
    }
}
@media (max-width: 390px){
    .labReportCardWrapper{
        .reportHeader{
            padding: 15px;
            justify-content: space-between;
            flex-direction: column;
            .appointmentDetail{
                justify-content: space-between;
                width: 100%;
                .appointmentDate{
                    left: 240px;
                    position: absolute;
                }
                .patient{
                    flex: 1;
                    margin-top: 2px;
                    .docName{
                        margin-top: 6px;
                    }
                }
            }
        } 
        .report_footer {
            .message_wrapper {
                span{
                    font-size: 14px;
                    margin-left: 10px;
                }
            }
        }
    }
}
@media (max-width: 325px){
    .labReportCardWrapper{
        .reportHeader{
            padding: 15px;
            justify-content: space-between;
            flex-direction: column;
            .appointmentDetail{
                justify-content: space-between;
                display: flex;
                width: 100%;
                .appointmentDate{
                    left: 186px;
                    position: absolute;
                }
                .patient{
                    .docName{
                        margin-top: 6px;
                    }
                }
            }
        } 
        .report_footer {
            .message_wrapper {
                span{
                    font-size: 14px;
                    margin-left: 10px;
                }
            }
        }
    }
}
`;
